import { inject, Injectable } from '@angular/core';
import { MessagesService } from '@services/messages.service';
import { stringIsEmpty } from '@sbfw/core';
import { handledApiErrors } from '@core/interceptors/api.error-messages';
import { APIErrorErrorResponse } from '@shared/models/base-api.model';

@Injectable({
    providedIn: 'root'
})
export class BaseErrorHandler {
    protected messageService = inject(MessagesService);
    protected handledErrors = handledApiErrors;

    handle404() {
        this.showErrorToast('ERROR_MESSAGES.GENERAL_API_ERROR');
    }

    handleApiError() {
        this.showErrorToast('ERROR_MESSAGES.GENERAL_API_ERROR');
    }

    handleError(err: APIErrorErrorResponse) {
        const { displayMessage } = err;

        const hasDisplayMessage = Object.hasOwn(err, 'displayMessage') && !stringIsEmpty(displayMessage);
        if (hasDisplayMessage) this.showErrorDialog(err);
        else {
            const message = this.getErrorMessage(err);
            this.showErrorToast(message);
        }
    }

    protected getErrorMessage(err: APIErrorErrorResponse): string {
        const { error } = err;
        console.info('GET Error Message:', handledApiErrors.includes(error));
        if (!handledApiErrors.includes(error)) return 'GENERAL_API_ERROR';
        else return error.toUpperCase();
    }

    protected showErrorDialog(err: APIErrorErrorResponse) {
        this.messageService.showErrorDialog({ message: err.message });
    }

    protected showErrorToast(message: string) {
        const msg = ['ERROR_MESSAGES', message].join('.');
        this.messageService.showError(msg);
    }
}
